import { createUseStyles } from 'react-jss';
import { CmsWrenchTheme } from '~app/styles/cmsTheme';

const useStyle = createUseStyles((theme: CmsWrenchTheme) => {
  const mediaQueryMinScreenMD = `@media (min-width: ${theme.breakpoints.md}px)`;
  const mediaQueryMinScreenLG = `@media (min-width: ${theme.breakpoints.lg}px)`;
  const mediaQueryMobileScreen = `@media (min-width: 0px) and (max-width:${theme.breakpoints.lg}px)`;

  const driveGetResultPadding = '50px 24px 48px';

  const variantClassMapping = {
    // Rebrand EP2025
    rebrandEP2025CtaWrapper: {
      maxWidth: 492,
    },
    rebrandEP2025BalancedText: {
      textWrap: '',
    },
    rebrandEP2025SubHeaderFontSize: {
      // The wrench Typography used does not allow addition of a classname
      '& > p': {
        fontSize: theme.type.fontSize.body,
        lineHeight: 1.5,
        [mediaQueryMinScreenLG]: {
          fontSize: '18px',
          maxWidth: 520,
          lineHeight: 1.8,
        },
      },
    },
    // Drive Get Results 2025
    // driveGetResults2025Variant1Box: { boxSpacing: theme.spacing[10] },
    driveGetResults2025Variant1Bg: {
      padding: '128px 94px 72px',
      [mediaQueryMobileScreen]: {
        padding: driveGetResultPadding,
        paddingBottom: '0px',
      },
    },
    driveGetResults2025Variant1CtaSection: {
      paddingTop: 50,
      [mediaQueryMobileScreen]: {
        paddingTop: '32px',
        paddingLeft: 'unset',
        paddingRight: 'unset',
      },
    },
    driveGetResults2025Variant2Bg: {
      padding: '128px 40px 0px',
      [mediaQueryMobileScreen]: {
        padding: driveGetResultPadding,
        paddingBottom: '0px',
      },
    },
    driveGetResults2025Variant2CtaSection: {
      [mediaQueryMobileScreen]: {
        paddingTop: '32px',
      },
    },
    driveGetResults2025Variant3resGripTemplate: {
      padding: '60px',
      [mediaQueryMobileScreen]: {
        padding: 'unset',
      },
    },
    driveGetResults2025Variant3Bg: {
      padding: '128px 94px 72px',
      [mediaQueryMobileScreen]: {
        padding: driveGetResultPadding,
        paddingBottom: '0px',
      },
    },
    driveGetResults2025Variant3CtaSection: {
      [mediaQueryMobileScreen]: {
        paddingTop: '32px',
      },
    },
  };

  return {
    darkBackground: {
      backgroundColor: theme.brandColors.primary.vine,
      paddingRight: theme.spacing[5],
      paddingLeft: theme.spacing[5],
      paddingTop: theme.spacing[6],
    },

    buttonBox: {
      display: 'block',
      [mediaQueryMinScreenMD]: {
        display: 'flex',
      },
    },

    headerFontSize: {
      // The wrench Typography used does not allow addition of a classname
      '& > section': {
        fontSize: theme.type.fontSize.hero2,
        marginTop: theme.spacing[2],
        [mediaQueryMinScreenLG]: {
          fontSize: theme.type.fontSize.hero1,
          minWidth: 500,
        },
      },
      '& > span': {
        letterSpacing: '2px',
      },
    },

    balancedText: {
      textWrap: 'balance',
    },

    subHeaderFontSize: {
      // The wrench Typography used does not allow addition of a classname
      '& > p': {
        fontSize: theme.type.fontSize.body,
        lineHeight: 1.8,
        maxWidth: 410,
      },
    },

    ctaForm: {
      margin: '0 auto',
      maxWidth: '380px',
    },

    logo: {
      height: 24,
      [mediaQueryMinScreenMD]: {
        height: 44,
      },
    },

    subHeader: {
      maxWidth: 400,
      [mediaQueryMinScreenMD]: {
        maxWidth: 600,
      },
      [mediaQueryMinScreenLG]: {
        maxWidth: 1000,
      },
    },

    bold: {
      fontWeight: 500,
    },

    strangeBox: {
      maxWidth: 550,
    },

    ctaWrapper: {
      maxWidth: 548,
    },

    headerDesktopPadding: {
      paddingTop: theme.spacing[5],
      [mediaQueryMinScreenMD]: {
        paddingBottom: theme.spacing[7],
        paddingTop: theme.spacing[9],
      },
    },

    imagePlacement: {
      width: '100%',
      maxWidth: 604,
      marginBottom: 0,
      [mediaQueryMinScreenMD]: {
        paddingLeft: theme.spacing[4],
      },
      [mediaQueryMinScreenLG]: {
        paddingLeft: 0,
      },
    },

    imageDesktop: {
      display: 'none',
      [mediaQueryMinScreenMD]: {
        display: 'block',
      },
    },

    imageMobile: {
      display: 'block',
      [mediaQueryMinScreenMD]: {
        display: 'none',
      },
    },

    resGripTemplate: {
      gridTemplateRows: '312px',
      [mediaQueryMinScreenMD]: {
        gridTemplateRows: '477px',
      },
    },
    ...variantClassMapping,
  };
});

export default useStyle;
